import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';
import { Link } from 'site-modules/shared/components/link/link';
import { getPlural } from 'client/utils/plural';

export function ConsumerRatingButton({
  total = null,
  makeSlug = null,
  modelSlug = null,
  year = null,
  oemConsumerReviewLink = null,
  trackingId = null,
  className = null,
  trackingValue = null,
  makeName = null,
  modelName = null,
}) {
  if (!(makeSlug && modelSlug && year && total)) {
    return null;
  }

  const ymmName = `${year} ${makeName} ${modelName}`;
  const labelName = `Read ${total} ${getPlural('review', total)}`;

  return (
    <Button
      className={classnames('px-1 py-0_5', className)}
      color="outline-primary-b"
      tag={Link}
      to={oemConsumerReviewLink || `/${makeSlug}/${modelSlug}/${year}/consumer-reviews/`}
      data-tracking-id={trackingId}
      data-tracking-value={trackingValue}
      aria-label={`${labelName} for ${ymmName}`}
    >
      {labelName}
    </Button>
  );
}

ConsumerRatingButton.propTypes = {
  total: PropTypes.number,
  makeSlug: PropTypes.string,
  modelSlug: PropTypes.string,
  year: PropTypes.number,
  oemConsumerReviewLink: PropTypes.string,
  trackingId: PropTypes.string,
  className: PropTypes.string,
  trackingValue: PropTypes.string,
  makeName: PropTypes.string,
  modelName: PropTypes.string,
};
